import type {
  CouponOutput,
  SubscriptionPackagesOutput,
} from '@/api/gql/graphql';
import { MenuDropdown } from '@/components/Common';
import { DataTable } from '@/components/Ui';
import { Status, useCoupons } from '@/pages/Coupons/coupons.hook';
import React from 'react';

const CouponList = () => {
  const {
    columns,
    statusConfig,
    couponList,
    setCouponListPage,
    couponListPage,
    couponListLimit,
    setCouponListLimit,
    menuItems,
    setCouponId,
  } = useCoupons();

  const getStatusDisplay = (status: string) => {
    const statusKey = status as Status;
    const config = statusConfig[statusKey];
    return config ? (
      <span className={config.color}>{config.label}</span>
    ) : (
      <span>{status}</span>
    );
  };

  const lists = couponList?.map((item: CouponOutput) => {
    return {
      ...item,
      package:
        item.packages &&
        item.packages.map((pk: SubscriptionPackagesOutput, index: number) => {
          return (
            <span key={pk._id}>
              {' '}
              {index > 0 && ','} {pk.type}
            </span>
          );
        }),
      discountValue:
        item.discountType === 'PERCENT'
          ? item.discountValue + ' %'
          : item.discountValue + ' Fcfa',
      status: getStatusDisplay(item.status.toLocaleUpperCase()),
      action: (
        <div onClick={() => setCouponId(item._id)}>
          <MenuDropdown menuItems={menuItems} dotsStyle="bg-[#FEC20033]" />
        </div>
      ),
    };
  });

  return (
    <div className="w-full">
      <DataTable
        columns={columns}
        value={lists || []}
        withPaginator={true}
        listlimit={lists && lists?.length < 30 ? 30 : couponListLimit}
        limitHandler={setCouponListLimit}
        countTotal={lists?.length}
        currentPage={couponListPage}
        currentPageHandler={setCouponListPage}
      />
    </div>
  );
};

export default CouponList;
